/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedAuctionSecondChanceOffer_item = {
    readonly " $fragmentRefs": FragmentRefs<"PriceDisplay_item" | "PdpSharedPurchaseButton_item">;
    readonly " $refType": "PdpSharedAuctionSecondChanceOffer_item";
};
export type PdpSharedAuctionSecondChanceOffer_item$data = PdpSharedAuctionSecondChanceOffer_item;
export type PdpSharedAuctionSecondChanceOffer_item$key = {
    readonly " $data"?: PdpSharedAuctionSecondChanceOffer_item$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedAuctionSecondChanceOffer_item">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedAuctionSecondChanceOffer_item",
  "selections": [
    {
      "args": [
        {
          "kind": "Variable",
          "name": "isTrade",
          "variableName": "isTrade"
        },
        {
          "kind": "Variable",
          "name": "userId",
          "variableName": "userId"
        }
      ],
      "kind": "FragmentSpread",
      "name": "PriceDisplay_item"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedPurchaseButton_item"
    }
  ],
  "type": "Item",
  "abstractKey": null
};
(node as any).hash = '0b8824f726d4017952048a89c178da20';
export default node;
